import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { LayoutState } from './types';

export const initialState: LayoutState = {
  isInactiveSamplePointErrorModalOpen: false,
  isNavigationVisible: true
};

function layoutReducer(
  state: LayoutState = initialState,
  action: ApplicationActions
): LayoutState {
  switch (action.type) {
    case ActionTypes.LAYOUT_SHOW_INACTIVE_SAMPLE_POINT_ERROR_MODAL: {
      return {
        ...state,
        isInactiveSamplePointErrorModalOpen: true
      };
    }
    case ActionTypes.LAYOUT_HIDE_INACTIVE_SAMPLE_POINT_ERROR_MODAL: {
      return {
        ...state,
        isInactiveSamplePointErrorModalOpen: false
      };
    }
    case ActionTypes.LAYOUT_SHOW_NAVIGATION: {
      return {
        ...state,
        isNavigationVisible: true
      };
    }
    case ActionTypes.LAYOUT_HIDE_NAVIGATION: {
      return {
        ...state,
        isNavigationVisible: false
      };
    }
    default:
      return state;
  }
};

export default layoutReducer;